// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DeliverySignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DeliverySignetIcon" ref={forwardedRef} {...props}>
      <path d="M18.815 10.533c-.018 2.546-2.129 4.583-4.675 4.583h-1.07a2.033 2.033 0 0 1-2.033-2.033v-1.411h2.26L10 7.969l-3.295 3.703h2.26v1.411a2.033 2.033 0 0 1-2.033 2.033h-2.93l-.005-.009a2.99 2.99 0 0 1-2.812-2.984c0-1.592 1.34-2.993 2.994-2.993q.038 0 .074.004C4.25 9.066 4.243 8.998 4.243 8.93a4.046 4.046 0 0 1 7.393-2.272 4.618 4.618 0 0 1 7.179 3.875" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DeliverySignetIcon = /* @__PURE__ */ Object.assign(
  DeliverySignetIconComponent,
  { displayName: 'DeliverySignetIcon' },
);
